import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../app/store';
import { getSubscriptionStatus } from '../app/ActionTypes/subscriptionActionTypes';
import { Notify } from '../services/notificationService';
import { trackEvent } from '../utils/monitoring';

/**
 * Hook to handle the redirect from Stripe Checkout after successful payment.
 * When Checkout completes, Stripe redirects back with ?checkout_success=true.
 * This hook detects that and shows a success message.
 */
export function useCheckoutSuccessHandler(): void {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('checkout_success') !== 'true') {
      return;
    }

    const priceId = params.get('price_id') || undefined;

    // Clear the query params immediately to prevent duplicate processing
    window.history.replaceState({}, document.title, window.location.pathname);

    // Track the event and show success message
    trackEvent('Subscription Created via Checkout', {
      price_id: priceId,
    });
    Notify.success('Your subscription has been activated!');

    // Refresh subscription data so the UI reflects the new subscription
    dispatch(getSubscriptionStatus());
  }, [dispatch]);
}
